import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '../error-utils';

export const { UnreachableError } = errorFactory('UnreachableError');

/** An error which indicates an unreachable branch of code has been reached. */
export type UnreachableError = InstanceTypeOf<typeof UnreachableError>;
